import { combineReducers } from "redux";
import userReducer from "./v2/user/reducer";
import favoriteReducer from "./v2/favorite/reducer";
import workoutReducer from "./v2/workout/reducer";
import exerciseReducerV2 from "./v2/exercise/reducer";
import programReducerV2 from "./v2/program/reducer";
import companyReducerV2 from "./v2/company/reducer";
import planReducerV2 from "./v2/plan/reducer";
import castReducerV2 from "./v2/cast/reducer";
import challengeReducerV2 from "./v2/challenge/reducer";
import utilsReducer from "./v2/utils/reducer";
import patientInviteReducer from "./v2/patient-invite/reducer";

export default combineReducers({
	// ===== V2
	User: userReducer,
	Favorite: favoriteReducer,
	Workout: workoutReducer,
	Exercise: exerciseReducerV2,
	Program: programReducerV2,
	Company: companyReducerV2,
	Plan: planReducerV2,
	Cast: castReducerV2,
	Challenge: challengeReducerV2,
	Utils: utilsReducer,
	PatientInvite: patientInviteReducer,
})